<template>
  <div class="mb-primary user-profile">
    <div class="card card-with-shadow py-primary border-0">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-5">
          <div class="media border-right h-100 px-primary user-header-media d-flex align-items-center">
            <div class="mr-primary">
              <app-input :wrapper-class="'circle small-wrapper mx-xl-auto'"
                         name="organization_logo"
                         type="custom-file-upload"
                         v-model="profile_picture"
                         :generate-file-url="false"
                         :label="$t('change')"
                         @change="changeProfile()"/>
            </div>

            <div class="media-body user-info-header">
              <template v-if="personUserInfo.contact_type">
                <app-badge :label="personUserInfo.contact_type.name"
                           :className="`badge-sm badge-pill badge-${personUserInfo.contact_type.class}`"/>
              </template>

              <div class="d-flex align-items-center text-muted font-size-90 mt-2"
                   v-if="personUserInfo['email']">
                <app-icon v-if="personUserInfo.email.length > 0" class="mr-2" stroke-width="1"
                          :name="'mail'"/>
                <p class="mb-0 text-break">
                  {{ personUserInfo.email.length > 0 ? personUserInfo.email[0].value : '' }}</p>
              </div>

              <div class="d-flex align-items-center text-muted font-size-90 mt-2"
                   v-if="personUserInfo['phone']">
                <app-icon v-if="personUserInfo.phone.length > 0" class="mr-2" stroke-width="1"
                          :name="'phone-call'"/>
                <p class="mb-0">{{ personUserInfo.phone.length > 0 ? personUserInfo.phone[0].value : '' }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-7">
          <div class="user-details px-5 px-sm-5 px-md-5 px-lg-0 px-xl-0 mt-5 mt-sm-5 mt-md-0 mt-lg-0 mt-xl-0">
            <div class="row">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                <div class="border-right h-100 custom d-flex flex-column justify-content-around">
                  <div class="media mb-4 mb-xl-5">
                    <div class="align-self-center mr-3">
                      <app-icon class="primary-text-color" stroke-width="1" :name="'user'"/>
                    </div>
                    <div class="media-body font-size-90">
                      <p class="text-muted mb-0">{{ $t('working_on') }}:</p>
                      <template v-if="personUserInfo.organizations.length > 0">
                        <p class="mb-0">{{ personUserInfo.organizations[0].name }}
                          {{ $t('and') }}
                          {{ personUserInfo.total_organizations - 1 }} {{ $t('more') }}</p>

                      </template>
                      <template v-else>
                        <p class="mb-0">{{ $t('no_persons_linked_yet') }}</p>
                      </template>

                    </div>
                  </div>
                  <div class="media mb-4 mb-xl-0">
                    <div class="align-self-center mr-3">
                      <app-icon class="primary-text-color" stroke-width="1" :name="'phone'"/>
                    </div>
                    <div class="media-body font-size-90">
                      <p class="text-muted mb-0">{{ $t('deals') }}:</p>
                      <p class="mb-0">{{ $t('closed') }}: {{ personUserInfo.closed_deals }},
                        {{ $t('open') }}:
                        {{ personUserInfo.open_deals }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                <div class="h-100 d-flex flex-column justify-content-around">
                  <div class="media mb-4 mb-xl-5">
                    <div class="align-self-center mr-3">
                      <app-icon class="primary-text-color" stroke-width="1" :name="'user'"/>
                    </div>
                    <div class="media-body font-size-90">
                      <p class="text-muted mb-0">{{ $t('owner') }}:</p>
                      <p class="mb-0" v-if="personUserInfo.owner">
                        {{ personUserInfo.owner.full_name }}
                      </p>
                    </div>
                  </div>
                  <div class="media mb-4 mb-xl-0">
                    <div class="align-self-center mr-3">
                      <app-icon class="primary-text-color" stroke-width="1" :name="'calendar'"/>
                    </div>
                    <div class="media-body font-size-90">
                      <p class="text-muted mb-0">{{ $t('created') }}:</p>
                      <p class="mb-0">{{ formatDateToLocal(personUserInfo.created_at) }}</p>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {FormMixin} from "@core/mixins/form/FormMixin.js";
import {formatDateToLocal,urlGenerator} from "@app/Helpers/helpers";

export default {
  name: "PersonUserInfo",
  props: ['personUserInfo'],
  mixins: [FormMixin],
  data() {
    return {
      profile_picture: '',
      formatDateToLocal
    }
  },
  methods: {
    changeProfile() {
      let formData = new FormData();
      formData.append('profile_picture', this.profile_picture);
      this.axiosPost({
        url: `crm/persons/profile-picture/${this.personUserInfo.id}`,
        data: formData
      }).then(response => {
        location.reload();
        this.$toastr.s(response.data.message);
      }).catch(({error}) => {
      })
    }
  },
  mounted() {
    this.profile_picture =
        this.personUserInfo.profile_picture ? urlGenerator(this.personUserInfo.profile_picture.path) : urlGenerator('/images/person.png');
  }
}
</script>
